export default "__VITE_ASSET__Bz4sm8FW__"